// Fichier de configuration pour Ace Editor
// Ceci centralise toutes les importations nécessaires

import ace from 'ace-builds/src-noconflict/ace';
import jsonWorkerUrl from 'ace-builds/src-noconflict/worker-json.js?url';

// Mode pour JSON
import 'ace-builds/src-noconflict/mode-json';

// Thème
import 'ace-builds/src-noconflict/theme-github';

// Extensions
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/ext-searchbox';

// Worker JSON : chemin absolu via Vite (évite /admin/exercises/edit/worker-json.js)
ace.config.setModuleUrl('ace/mode/json_worker', jsonWorkerUrl);

export default {}; 